export class CaracteristicaValor {
    constructor(
        public IdCaracteristicaValor?: string | number,
        public descripcion: string = ''
    ) { }
}